import { useMemo } from 'react';
import CardHeaderInfoPopover from '../../common/CardHeaderInfoPopover';
import ProjectsBreakdownSection from '../../common/ProjectsBreakdownSection';
import { useFirestoreGeneral } from '../../../firebase/useFirestore';
import { BarChart, Bar, XAxis, YAxis, Tooltip as RechartsTooltip, ResponsiveContainer } from 'recharts';
import buildWeeklyResponseBuckets from '../../../helpers/dataHelpers/buildWeeklyResponseBuckets';
import { CHART_MARK_STROKE, CHART_MARK_STROKE_WIDTH } from '../../../helpers/chartPalette';

/**
 * Inline info popover for event-field charts (Multiple/Scale). Renders the
 * Activiteit + Resultaten rows plus a weekly bucket chart of the field's
 * EventResults — same shape as EventOpenData's modal.
 *
 * @param {object} props
 * @param {{ ID: string, Title?: string }} props.field
 * @param {string} [props.activityId]
 * @param {number} [props.totalResponses]
 * @param {object} [props.projectHierarchy] - { [projectName]: { totalDocs, ... } } from useHierarchyData
 */
const EventFieldInfoPopover = ({ field, activityId, totalResponses, projectHierarchy }) => {
    const activities = useFirestoreGeneral('Activities', 'ID', activityId || '');
    const activityName = (activities && activities[0] && activities[0].Activity) || '—';
    const eventResults = useFirestoreGeneral('EventResults', 'FieldID', field?.ID || '');

    const weeklyResultData = useMemo(
        () => buildWeeklyResponseBuckets(eventResults),
        [eventResults]
    );

    return (
        <CardHeaderInfoPopover
            label="Details"
            content={(
                <div>
                    <div className="info-popover-row">
                        <span className="info-popover-row-label">Activiteit</span>
                        <span className="info-popover-row-value">{activityName}</span>
                    </div>
                    <div className="info-popover-row">
                        <span className="info-popover-row-label">Resultaten</span>
                        <span className="info-popover-row-value">{totalResponses ?? 0}</span>
                    </div>
                    {weeklyResultData.length > 0 && (
                        <div className="info-popover-chart">
                            <p className="info-popover-chart-title">Resultaten per week</p>
                            <ResponsiveContainer width="100%" height={250}>
                                <BarChart data={weeklyResultData} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
                                    <XAxis dataKey="name" axisLine={false} tickLine={false} />
                                    <YAxis allowDecimals={false} axisLine={false} tickLine={false} />
                                    <RechartsTooltip />
                                    <Bar dataKey="value" fill="#47acc3" stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    )}
                    <ProjectsBreakdownSection hierarchy={projectHierarchy} valueLabel="Resultaten" />
                </div>
            )}
        />
    );
};

export default EventFieldInfoPopover;
